import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sanwei",
  "use": "icon-sanwei-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"https://www.w3.org/2000/svg\" xmlns:xlink=\"https://www.w3.org/1999/xlink\" id=\"icon-sanwei\">\n  <path d=\"M879.1 297.8L511.3 479.3 143.5 297.8c-20.2-10.7-18.9-36.1 1.3-45.4l339.6-148.2c16.6-8 35.9-8 52.5 0L876.4 251c23 10.7 23 36.1 2.7 46.8zM437.2 921.2L126 753c-18.8-9.3-29.6-25.4-29.6-44V371.2c0-20 25.6-32.1 44.5-21.4l346 174.8v377.2c1.2 18.7-26.1 34-49.7 19.4z m149.6 0L898.1 753c17.5-9.3 28.3-25.4 28.3-44V371.2c0-20-25.6-32.1-44.5-21.4L533.1 524.4v377.1c0 20 28.1 36.5 53.6 19.7h0.1z\" p-id=\"12138\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/sanwei.svg
// module id = yP7h
// module chunks = 12